/* eslint-disable */

export const getScheduledOrdersConstants = {
    GET_SCHEDULED_ORDERS_REQUEST: 'GET_SCHEDULED_ORDERS_REQUEST',
    GET_SCHEDULED_ORDERS_SUCCESS: 'GET_SCHEDULED_ORDERS_SUCCESS',
    GET_SCHEDULED_ORDERS_FAILURE: 'GET_SCHEDULED_ORDERS_FAILURE',
};
